import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {Helmet} from 'react-helmet';
import { useDispatch, useSelector } from "react-redux";
import AboutUs from "../aboutus";
import Faqs from "../faqs";
import Portfolios from "../portfolios";
import Features from "../features";
import Pricing from "../pricing";
import Services from "../services";
import Teams from "../teams";
import Testimonials from "../testimonials";
import Clients from "../clients";
import Certificate from "../Certificate";
import Contact from "../contact";

const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What features are included in your website development service?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I include responsive design, fast loading, SEO optimization, mobile-first approach, CMS setup, contact forms, image optimization, and cross-browser compatibility."
      }
    },
    {
      "@type": "Question",
      "name": "Are your websites mobile-friendly?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, every website I build is mobile-friendly and works seamlessly on smartphones, tablets, and desktops."
      }
    },
    {
      "@type": "Question",
      "name": "Do your websites support SEO best practices?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. I implement on-page SEO best practices including meta tags, alt texts, sitemap generation, and clean URL structures."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer performance optimization?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. All sites are optimized for speed with minimized code, compressed images, and lazy-loading techniques."
      }
    },
    {
      "@type": "Question",
      "name": "Can I manage website content myself?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I use WordPress or custom CMS options that let you easily update text, images, and pages without technical knowledge."
      }
    },
    {
      "@type": "Question",
      "name": "Are the websites secure?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I implement SSL (HTTPS), security headers, anti-spam measures, and protection against common vulnerabilities."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide backup functionality?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I configure automated backups for your website to ensure data protection and quick recovery."
      }
    },
    {
      "@type": "Question",
      "name": "Can I track user traffic on my site?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I integrate tools like Google Analytics and Search Console for traffic monitoring and SEO performance."
      }
    },
    {
      "@type": "Question",
      "name": "Do your websites support e-commerce features?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I build e-commerce functionality using WooCommerce or custom solutions with features like cart, checkout, and payment gateway integration."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be optimized for conversions?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I follow UX/UI best practices to design user journeys that help increase leads, signups, and purchases."
      }
    },
    {
      "@type": "Question",
      "name": "Do you include social media integration?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I include social media icons, share buttons, and feed integration based on your preferences."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help with domain and hosting setup?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I offer complete setup including domain registration, hosting configuration, and DNS setup."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide contact forms with spam protection?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I build responsive contact forms with reCAPTCHA and validation to reduce spam."
      }
    },
    {
      "@type": "Question",
      "name": "Can I have a blog or news section?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I can set up a full-featured blog with categories, tags, and commenting functionality."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website have a sitemap and robots.txt?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I generate and submit an XML sitemap and configure robots.txt to help search engines index your site correctly."
      }
    },
    {
      "@type": "Question",
      "name": "Is your design custom or template-based?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Both options are available. I can create fully custom designs or customize high-quality templates based on your budget."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide favicon and custom branding?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I include favicon, custom logo placement, brand colors, and typography setup as part of branding."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help me with email setup?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I help configure domain-based email addresses and connect them to services like Gmail or Outlook."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be compatible with all browsers?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I test your website across major browsers like Chrome, Firefox, Safari, Edge, and Opera for consistent performance."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer multilingual website support?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I can build multilingual websites using WPML or other translation plugins or frameworks."
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
    <title>Features - Website Designers In Gurgaon</title>
  <meta name="description" content="Website designing company in gurgaon, Delhi, Noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India."/>
  <meta name="keywords" content="pankaj, pankj, web designers near me, website designer near me, web designing company in gurgaon, website designing company in gurgaon, website development company in gurgaon,freelance web designer, web design gurgaon, website design gurgaon, web design companies near me, web design company, website design company"/>
<meta property="og:title" content="Features - Website designing company in gurgaon | website development company in gurgaon" />
<meta property="og:description" content="Website designing company in gurgaon, Delhi, Noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India." />
<meta property="og:site_name" content="Features - Website designing company in gurgaon | website development company in gurgaon" />
<meta property="og:url" content="https://www.pankj.com/contact"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Features - Website designing company in gurgaon | website development company in gurgaon" />
<meta name="twitter:description" content="Website designing company in gurgaon, delhi, noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India." />
<link rel="canonical" href="https://www.pankj.com/contact" />
        </Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
        <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
 <h1 className="multiple_effects" id="text3d">Features</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="Web Designing Company In Gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   



    <main id="main">

 <Features />
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
